import { createApi } from '@reduxjs/toolkit/query/react'
import { deviceInfoAxiosQuery } from '../../utils/axios/deviceInfo.axios'
import { TripApiResponse } from '../../interfaces/trips/ITrips'
import { INotifications } from '../../interfaces/staff/notifications/INotifications'

export const tripsApi = createApi({
    reducerPath: 'trips',
    baseQuery: deviceInfoAxiosQuery(),
	tagTypes: ['trips', 'latest-trip', 'notifications'],
    endpoints: (builder) => ({
		getReviews: builder.mutation<any, void>({
			query: () => ({
				url: `/rebecca-ai-agent/rebecca-reviews/download`,
				method: 'PUT',
			}),
		}),
		getTrips: builder.query<TripApiResponse[], string>({
			query: (crewMemberId) => ({
				url: `/trips/by-cabin-assignment/${crewMemberId}`,
				method: 'GET',
			}),
			providesTags: ['trips']
		}),
		getNotifications: builder.mutation<INotifications, {recipientId: string, page: number, limit: number}>({
			query: ({recipientId, page, limit}) => ({
				url: `/notifications/list?page=${page || 1}&size=${limit || 10}`,
				method: 'POST',
				data: {recipientId: recipientId}
			}),
		}),
		readNotification: builder.mutation<INotifications, string>({
			query: (notificationId) => ({
				url: `/notifications/${notificationId}`,
				method: 'PATCH',
				data: {read: true}
			}),
			invalidatesTags: ['notifications']
		}),
		loginCrewTrip: builder.mutation<TripApiResponse[], string>({
			query: (crewMemberId) => ({
				url: `/crew-login/${crewMemberId}`,
				method: 'PATCH',
			}),
			invalidatesTags: ['latest-trip']
		}),
		getLatestTrip: builder.query<TripApiResponse[], string>({
			query: (crewMemberId) => ({
				url: `/trips/latest-active-trip/${crewMemberId}`,
				method: 'GET',
			}),
			providesTags: ['latest-trip']
		}),
		assignCabinToCrew: builder.query<TripApiResponse[], {crewMemberId: string, tripId: string}>({
			query: ({crewMemberId, tripId}) => ({
				url: `trips/assigned-cabins/${tripId}/${crewMemberId}`,
				method: 'PATCH',
			}),
			providesTags: ['latest-trip']
		}),
		getLatestVisibleTrips: builder.query<TripApiResponse[], string>({
			query: (userId) => ({
			  url: `/trips/latest-active-trip-visible/${userId}`,
			  method: 'GET',
			}),
		}),
		notificationUnreadCount: builder.query<{userId: string, unreadCount: number}, string>({
			query: (userId) => ({
			  url: `/notifications/unread-count/${userId}`,
			  method: 'GET',
			}),
			providesTags: ['notifications'],
		}),
    }),
})

export const {
	useNotificationUnreadCountQuery,
	useGetLatestVisibleTripsQuery,
	useReadNotificationMutation,
	useGetNotificationsMutation,
	useGetTripsQuery,
	useGetLatestTripQuery,
	useLoginCrewTripMutation,
	useAssignCabinToCrewQuery,
	useGetReviewsMutation
} = tripsApi